import { useRef } from "react";
import { Ban, Clock3, Printer, RotateCcw } from "lucide-react";
import PrintKot from "../../component/PrintKOT/PrintKOT";
import { useTrackedPrint } from "../../Utills/useTrackedPrint";

const KdsTicketCard = ({ item, status, busy, onTransition, onRecall, onCancel, nextLabel }) => {
  const printRef = useRef();
  const print = useTrackedPrint({
    contentRef: printRef,
    documentType: "KOT",
    getDocumentId: () => item.state.kitchenTicketItemStateId,
  });
  const printItems = [{
    foodName: item.itemName,
    qty: item.quantity,
    note: item.note,
    addonSummary: item.addonSummary,
  }];
  const isBusy = busy === item.state.kitchenTicketItemStateId;
  const sourceLabel = item.sourceType === "TAKEAWAY" ? "Takeaway" : "Dine-in";

  return (
    <article className={`kds-ticket${item.isOverdue ? " is-overdue" : ""}`}>
      <div className="kds-ticket-head">
        <div className="kds-ticket-identity">
          <span>{sourceLabel}</span>
          <strong>{item.location} {"\u00B7"} #{item.orderReference}</strong>
        </div>
        <span className="kds-ticket-time"><Clock3 size={15} /> {item.elapsedMinutes} min</span>
      </div>

      <h3><span>{item.quantity}{"\u00D7"}</span>{item.itemName}</h3>
      {item.addonSummary && <p className="kds-addons"><strong>Add-ons:</strong> {item.addonSummary}</p>}
      {item.note && <p className="kds-note"><strong>Item note</strong><span>{item.note}</span></p>}

      <div className="kds-ticket-tools">
        <button type="button" className="secondary" onClick={print}><Printer size={16} /> Print KOT</button>
        <button type="button" className="danger" disabled={isBusy} onClick={() => onCancel(item)}>
          <Ban size={16} /> {item.sourceType === "TAKEAWAY" ? "Cancel order" : "Cancel item"}
        </button>
      </div>

      <div className="kds-ticket-actions">
        {status === "READY" && (
          <button type="button" className="secondary" disabled={isBusy} onClick={() => onRecall(item)} title="Recall or re-fire">
            <RotateCcw size={17} /> Recall
          </button>
        )}
        <button type="button" className="primary" disabled={isBusy} onClick={() => onTransition(item)}>
          {isBusy ? "Updating..." : nextLabel}
        </button>
      </div>

      <div className="kds-print">
        <div ref={printRef}>
          <h2>{item.location} {"\u00B7"} {item.orderReference}</h2>
          <PrintKot items={printItems} bill={{ tableNumber: item.location, tokenNumber: item.orderReference }} liveOrderKot />
        </div>
      </div>
    </article>
  );
};

export default KdsTicketCard;
